import { customerPortal } from "@vilocnv/allsetra-core";
import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { getGeozoneByIdAction } from "../actions/get-geozone-by-id.action";

type GeozonesState = customerPortal.geozones.GeozonesState;

const getGeozoneByIdCases = (
  builder: ActionReducerMapBuilder<GeozonesState>
) => {
  builder.addCase(getGeozoneByIdAction.pending, (state) => {
    state.isLoadingSelectedGeozone = true;
  });
  builder.addCase(getGeozoneByIdAction.fulfilled, (state, action) => {
    state.selectedGeozone = action.payload;
    state.isLoadingSelectedGeozone = false;
  });
  builder.addCase(getGeozoneByIdAction.rejected, (state) => {
    state.isLoadingSelectedGeozone = false;
  });
};

export default getGeozoneByIdCases;
